export default [
  {
    "area_code": "+66",
    "country_id": 172,
    "name_cn": "泰国",
    "name_en": "Thailand"
  },
  {
    "area_code": "+1",
    "country_id": '',
    "name_cn": "美国",
    "name_en": "Amerancra"
  },
  {
    "area_code": "+86",
    "country_id": 37,
    "name_cn": "中国大陆",
    "name_en": "China"
  },
  {
    "area_code": "+852",
    "country_id": 71,
    "name_cn": "中国香港",
    "name_en": "Hong Kong (China)"
  },
  {
    "area_code": "+853",
    "country_id": 500,
    "name_cn": "中国澳门",
    "name_en": "Macao (China)"
  },
  {
    "area_code": "+886",
    "country_id": 169,
    "name_cn": "中国台湾",
    "name_en": "Taiwan (China)"
  },
  {
    "area_code": "+355",
    "country_id": 3,
    "name_cn": "阿尔巴尼亚",
    "name_en": "Albania"
  },
  {
    "area_code": "+213",
    "country_id": 4,
    "name_cn": "阿尔及利亚",
    "name_en": "Algeria"
  },
  {
    "area_code": "+376",
    "country_id": 5,
    "name_cn": "安道尔共和国",
    "name_en": "Andorra"
  },
  {
    "area_code": "+244",
    "country_id": 1,
    "name_cn": "安哥拉",
    "name_en": "Angola"
  },
  {
    "area_code": "+1264",
    "country_id": 6,
    "name_cn": "安圭拉岛",
    "name_en": "Anguilla"
  },
  {
    "area_code": "+1268",
    "country_id": 7,
    "name_cn": "安提瓜和巴布达",
    "name_en": "Antigua and Barbuda"
  },
  {
    "area_code": "+54",
    "country_id": 8,
    "name_cn": "阿根廷",
    "name_en": "Argentina"
  },
  {
    "area_code": "+297",
    "country_id": 194,
    "name_cn": "阿鲁巴",
    "name_en": "Aruba"
  },
  {
    "area_code": "+247",
    "country_id": 10,
    "name_cn": "阿森松",
    "name_en": "Ascension"
  },
  {
    "area_code": "+61",
    "country_id": 11,
    "name_cn": "澳大利亚",
    "name_en": "Australia"
  },
  {
    "area_code": "+672",
    "country_id": 195,
    "name_cn": "澳大利亚海外领地",
    "name_en": "Australianoverseasterritories"
  },
  {
    "area_code": "+43",
    "country_id": 12,
    "name_cn": "奥地利",
    "name_en": "Austria"
  },
  {
    "area_code": "+994",
    "country_id": 13,
    "name_cn": "阿塞拜疆",
    "name_en": "Azerbaijan"
  },
  {
    "area_code": "+20",
    "country_id": 49,
    "name_cn": "埃及",
    "name_en": "Egypt"
  },
  {
    "area_code": "+372",
    "country_id": 51,
    "name_cn": "爱沙尼亚",
    "name_en": "Estonia"
  },
  {
    "area_code": "+251",
    "country_id": 52,
    "name_cn": "埃塞俄比亚",
    "name_en": "Ethiopia"
  },
  {
    "area_code": "+353",
    "country_id": 78,
    "name_cn": "爱尔兰",
    "name_en": "Ireland"
  },
  {
    "area_code": "+968",
    "country_id": 128,
    "name_cn": "阿曼",
    "name_en": "Oman"
  },
  {
    "area_code": "+971",
    "country_id": 181,
    "name_cn": "阿拉伯联合酋长国",
    "name_en": "United Arab Emirates"
  },
  {
    "area_code": "+1242",
    "country_id": 14,
    "name_cn": "巴哈马",
    "name_en": "Bahamas"
  },
  {
    "area_code": "+973",
    "country_id": 15,
    "name_cn": "巴林",
    "name_en": "Bahrain"
  },
  {
    "area_code": "+1246",
    "country_id": 17,
    "name_cn": "巴巴多斯",
    "name_en": "Barbados"
  },
  {
    "area_code": "+32",
    "country_id": 19,
    "name_cn": "比利时",
    "name_en": "Belgium"
  },
  {
    "area_code": "+501",
    "country_id": 20,
    "name_cn": "伯利兹",
    "name_en": "Belize"
  },
  {
    "area_code": "+229",
    "country_id": 21,
    "name_cn": "贝宁",
    "name_en": "Benin"
  },
  {
    "area_code": "+1441",
    "country_id": 22,
    "name_cn": "百慕大群岛",
    "name_en": "Bermuda"
  },
  {
    "area_code": "+975",
    "country_id": 196,
    "name_cn": "不丹",
    "name_en": "Bhutan"
  },
  {
    "area_code": "+387",
    "country_id": 197,
    "name_cn": "波斯尼亚和黑塞哥维那",
    "name_en": "BosniaandHerzegovina"
  },
  {
    "area_code": "+267",
    "country_id": 24,
    "name_cn": "博茨瓦纳",
    "name_en": "Botswana"
  },
  {
    "area_code": "+55",
    "country_id": 25,
    "name_cn": "巴西",
    "name_en": "Brazil"
  },
  {
    "area_code": "+359",
    "country_id": 27,
    "name_cn": "保加利亚",
    "name_en": "Bulgaria"
  },
  {
    "area_code": "+226",
    "country_id": 28,
    "name_cn": "布基纳法索",
    "name_en": "Burkina Faso"
  },
  {
    "area_code": "+257",
    "country_id": 30,
    "name_cn": "布隆迪",
    "name_en": "Burundi"
  },
  {
    "area_code": "+855",
    "country_id": 85,
    "name_cn": "柬埔寨",
    "name_en": "Cambodia"
  },
  {
    "area_code": "+253",
    "country_id": 46,
    "name_cn": "吉布提",
    "name_en": "Djibouti"
  },
  {
    "area_code": "+354",
    "country_id": 73,
    "name_cn": "冰岛",
    "name_en": "Iceland"
  },
  {
    "area_code": "+970",
    "country_id": 219,
    "name_cn": "巴勒斯坦",
    "name_en": "Palestine"
  },
  {
    "area_code": "+507",
    "country_id": 130,
    "name_cn": "巴拿马",
    "name_en": "Panama"
  },
  {
    "area_code": "+675",
    "country_id": 131,
    "name_cn": "巴布亚新几内亚",
    "name_en": "Papua New Cuinea"
  },
  {
    "area_code": "+595",
    "country_id": 132,
    "name_cn": "巴拉圭",
    "name_en": "Paraguay"
  },
  {
    "area_code": "+51",
    "country_id": 133,
    "name_cn": "秘鲁",
    "name_en": "Peru"
  },
  {
    "area_code": "+48",
    "country_id": 135,
    "name_cn": "波兰",
    "name_en": "Poland"
  },
  {
    "area_code": "+240",
    "country_id": 203,
    "name_cn": "赤道几内亚",
    "name_en": "EquatorialGuinea"
  },
  {
    "area_code": "+49",
    "country_id": 60,
    "name_cn": "德国",
    "name_en": "Germany"
  },
  {
    "area_code": "+684",
    "country_id": 145,
    "name_cn": "东萨摩亚(美)",
    "name_en": "Samoa Eastern"
  },
  {
    "area_code": "+228",
    "country_id": 173,
    "name_cn": "多哥",
    "name_en": "Togo"
  },
  {
    "area_code": "+45",
    "country_id": 45,
    "name_cn": "丹麦",
    "name_en": "Denmark"
  },
  {
    "area_code": "+1809",
    "country_id": 47,
    "name_cn": "多米尼加共和国",
    "name_en": "Dominican Republic"
  },
  {
    "area_code": "+670",
    "country_id": 202,
    "name_cn": "东帝汶",
    "name_en": "EastTimor"
  },
  {
    "area_code": "+9714",
    "country_id": 230,
    "name_cn": "迪拜酋长国",
    "name_en": "Emirate of Dubai"
  },
  {
    "area_code": "+291",
    "country_id": 204,
    "name_cn": "厄立特里亚",
    "name_en": "Eritrea"
  },
  {
    "area_code": "+7",
    "country_id": 142,
    "name_cn": "俄罗斯",
    "name_en": "Russia"
  },
  {
    "area_code": "+238",
    "country_id": 198,
    "name_cn": "佛得角",
    "name_en": "CapeVerde"
  },
  {
    "area_code": "+500",
    "country_id": 205,
    "name_cn": "福克兰群岛",
    "name_en": "FalklandIslands"
  },
  {
    "area_code": "+298",
    "country_id": 206,
    "name_cn": "法罗群岛",
    "name_en": "FaroeIslands"
  },
  {
    "area_code": "+679",
    "country_id": 53,
    "name_cn": "斐济",
    "name_en": "Fiji"
  },
  {
    "area_code": "+358",
    "country_id": 54,
    "name_cn": "芬兰",
    "name_en": "Finland"
  },
  {
    "area_code": "+33",
    "country_id": 55,
    "name_cn": "法国",
    "name_en": "France"
  },
  {
    "area_code": "+594",
    "country_id": 56,
    "name_cn": "法属圭亚那",
    "name_en": "French Guiana"
  },
  {
    "area_code": "+689",
    "country_id": 136,
    "name_cn": "法属玻利尼西亚",
    "name_en": "French Polynesia"
  },
  {
    "area_code": "+63",
    "country_id": 134,
    "name_cn": "菲律宾",
    "name_en": "Philippines"
  },
  {
    "area_code": "+379",
    "country_id": 227,
    "name_cn": "梵蒂冈城",
    "name_en": "VaticanCity"
  },
  {
    "area_code": "+57",
    "country_id": 38,
    "name_cn": "哥伦比亚",
    "name_en": "Colombia"
  },
  {
    "area_code": "+506",
    "country_id": 41,
    "name_cn": "哥斯达黎加",
    "name_en": "Costa Rica"
  },
  {
    "area_code": "+220",
    "country_id": 58,
    "name_cn": "冈比亚",
    "name_en": "Gambia"
  },
  {
    "area_code": "+995",
    "country_id": 59,
    "name_cn": "格鲁吉亚",
    "name_en": "Georgia"
  },
  {
    "area_code": "+299",
    "country_id": 207,
    "name_cn": "格陵兰岛",
    "name_en": "Greenland"
  },
  {
    "area_code": "+1473",
    "country_id": 64,
    "name_cn": "格林纳达",
    "name_en": "Grenada"
  },
  {
    "area_code": "+590",
    "country_id": 208,
    "name_cn": "瓜德罗普",
    "name_en": "Guadeloupe"
  },
  {
    "area_code": "+1671",
    "country_id": 65,
    "name_cn": "关岛",
    "name_en": "Guam"
  },
  {
    "area_code": "+592",
    "country_id": 68,
    "name_cn": "圭亚那",
    "name_en": "Guyana"
  },
  {
    "area_code": "+509",
    "country_id": 69,
    "name_cn": "海地",
    "name_en": "Haiti"
  },
  {
    "area_code": "+504",
    "country_id": 70,
    "name_cn": "洪都拉斯",
    "name_en": "Honduras"
  },
  {
    "area_code": "+82",
    "country_id": 88,
    "name_cn": "韩国",
    "name_en": "Korea"
  },
  {
    "area_code": "+382",
    "country_id": 215,
    "name_cn": "黑山",
    "name_en": "Montenegro"
  },
  {
    "area_code": "+599",
    "country_id": 120,
    "name_cn": "荷属安的列斯",
    "name_en": "Netheriands Antilles"
  },
  {
    "area_code": "+31",
    "country_id": 121,
    "name_cn": "荷兰",
    "name_en": "Netherlands"
  },
  {
    "area_code": "+81",
    "country_id": 32,
    "name_cn": "日本",
    "name_en": "Japan"
  },
  {
    "area_code": "+1",
    "country_id": 32,
    "name_cn": "加拿大",
    "name_en": "Canada"
  },
  {
    "area_code": "+420",
    "country_id": 44,
    "name_cn": "捷克",
    "name_en": "Czech Republic"
  },
  {
    "area_code": "+241",
    "country_id": 57,
    "name_cn": "加蓬",
    "name_en": "Gabon"
  },


  {
    "area_code": "+233",
    "country_id": 61,
    "name_cn": "加纳",
    "name_en": "Ghana"
  },
  {
    "area_code": "+245",
    "country_id": 209,
    "name_cn": "几内亚比绍",
    "name_en": "Guinea-Bissau"
  },
  {
    "area_code": "+686",
    "country_id": 210,
    "name_cn": "基里巴斯",
    "name_en": "Kiribati"
  },
  {
    "area_code": "+996",
    "country_id": 90,
    "name_cn": "吉尔吉斯坦",
    "name_en": "Kyrgyzstan"
  },
  {
    "area_code": "+1345",
    "country_id": 33,
    "name_cn": "开曼群岛",
    "name_en": "Cayman Islands."
  },
  {
    "area_code": "+269",
    "country_id": 199,
    "name_cn": "科摩罗群岛",
    "name_en": "ComorosIslands"
  },
  {
    "area_code": "+682",
    "country_id": 40,
    "name_cn": "库克群岛",
    "name_en": "Cook Islands."
  },

  {
    "area_code": "+385",
    "country_id": 200,
    "name_cn": "克罗地亚",
    "name_en": "Croatia"
  },
  {
    "area_code": "+254",
    "country_id": 87,
    "name_cn": "肯尼亚",
    "name_en": "Kenya"
  },
 

  {
    "area_code": "+965",
    "country_id": 89,
    "name_cn": "科威特",
    "name_en": "Kuwait"
  },
  {
    "area_code": "+974",
    "country_id": 139,
    "name_cn": "卡塔尔",
    "name_en": "Qatar"
  },
  {
    "area_code": "+856",
    "country_id": 91,
    "name_cn": "老挝",
    "name_en": "Laos"
  },
  {
    "area_code": "+371",
    "country_id": 92,
    "name_cn": "拉脱维亚",
    "name_en": "Latvia"
  },
  {
    "area_code": "+266",
    "country_id": 94,
    "name_cn": "莱索托",
    "name_en": "Lesotho"
  },
  {
    "area_code": "+423",
    "country_id": 97,
    "name_cn": "列支敦士登",
    "name_en": "Liechtenstein"
  },
  {
    "area_code": "+370",
    "country_id": 98,
    "name_cn": "立陶宛",
    "name_en": "Lithuania"
  },
  {
    "area_code": "+352",
    "country_id": 99,
    "name_cn": "卢森堡",
    "name_en": "Luxembourg"
  },
  {
    "area_code": "+262",
    "country_id": 140,
    "name_cn": "留尼旺",
    "name_en": "Reunion"
  },
  {
    "area_code": "+40",
    "country_id": 141,
    "name_cn": "罗马尼亚",
    "name_en": "Romania"
  },

  {
    "area_code": "+250",
    "country_id": 220,
    "name_cn": "卢旺达",
    "name_en": "Rwanda"
  },
  {
    "area_code": "+389",
    "country_id": 211,
    "name_cn": "马其顿",
    "name_en": "Macedonia"
  },
  {
    "area_code": "+261",
    "country_id": 101,
    "name_cn": "马达加斯加",
    "name_en": "Madagascar"
  },
  {
    "area_code": "+265",
    "country_id": 102,
    "name_cn": "马拉维",
    "name_en": "Malawi"
  },
  {
    "area_code": "+60",
    "country_id": 103,
    "name_cn": "马来西亚",
    "name_en": "Malaysia"
  },
  {
    "area_code": "+960",
    "country_id": 104,
    "name_cn": "马尔代夫",
    "name_en": "Maldives"
  },
  {
    "area_code": "+223",
    "country_id": 105,
    "name_cn": "马里",
    "name_en": "Mali"
  },
  {
    "area_code": "+356",
    "country_id": 106,
    "name_cn": "马耳他",
    "name_en": "Malta"
  },
  {
    "area_code": "+223",
    "country_id": 107,
    "name_cn": "马里亚那群岛",
    "name_en": "Marshall Islands"
  },
  {
    "area_code": "+692",
    "country_id": 212,
    "name_cn": "马绍尔群岛",
    "name_en": "MarshallIslands"
  },
  {
    "area_code": "+596",
    "country_id": 108,
    "name_cn": "马提尼克",
    "name_en": "Martinique"
  },
  {
    "area_code": "+222",
    "country_id": 213,
    "name_cn": "毛里塔尼亚",
    "name_en": "Mauritania"
  },
  {
    "area_code": "+230",
    "country_id": 109,
    "name_cn": "毛里求斯",
    "name_en": "Mauritius"
  },
  {
    "area_code": "+52",
    "country_id": 110,
    "name_cn": "墨西哥",
    "name_en": "Mexico"
  },
  {
    "area_code": "+691",
    "country_id": 214,
    "name_cn": "密克罗尼西亚",
    "name_en": "Micronesia"
  },
  {
    "area_code": "+373",
    "country_id": 111,
    "name_cn": "摩尔多瓦",
    "name_en": "Moldova"
  },
  {
    "area_code": "+377",
    "country_id": 112,
    "name_cn": "摩纳哥",
    "name_en": "Monaco"
  },
  {
    "area_code": "+976",
    "country_id": 113,
    "name_cn": "蒙古",
    "name_en": "Mongolia"
  },

  {
    "area_code": "+1664",
    "country_id": 114,
    "name_cn": "蒙特塞拉特岛",
    "name_en": "Montserrat"
  },
  {
    "area_code": "+212",
    "country_id": 115,
    "name_cn": "摩洛哥",
    "name_en": "Morocco"
  },
  {
    "area_code": "+258",
    "country_id": 116,
    "name_cn": "莫桑比克",
    "name_en": "Mozambique"
  },
  {
    "area_code": "+264",
    "country_id": 117,
    "name_cn": "纳米比亚",
    "name_en": "Namibia"
  },
  {
    "area_code": "+674",
    "country_id": 118,
    "name_cn": "瑙鲁",
    "name_en": "Nauru"
  },
  {
    "area_code": "+977",
    "country_id": 119,
    "name_cn": "尼泊尔",
    "name_en": "Nepal"
  },
  {
    "area_code": "+227",
    "country_id": 124,
    "name_cn": "尼日尔",
    "name_en": "Niger"
  },
  {
    "area_code": "+234",
    "country_id": 125,
    "name_cn": "尼日利亚",
    "name_en": "Nigeria"
  },
  {
    "area_code": "+683",
    "country_id": 217,
    "name_cn": "纽埃岛",
    "name_en": "Niue"
  },
  {
    "area_code": "+47",
    "country_id": 127,
    "name_cn": "挪威",
    "name_en": "Norway"
  },
  {
    "area_code": "+27",
    "country_id": 158,
    "name_cn": "南非",
    "name_en": "South Africa"
  },
  {
    "area_code": "+338",
    "country_id": 189,
    "name_cn": "南斯拉夫",
    "name_en": "Yugoslavia"
  },
  {
    "area_code": "+680",
    "country_id": 218,
    "name_cn": "帕劳",
    "name_en": "Palau"
  },
  


  {
    "area_code": "+351",
    "country_id": 137,
    "name_cn": "葡萄牙",
    "name_en": "Portugal"
  },
  {
    "area_code": "+001787",
    "country_id": 138,
    "name_cn": "波多黎各",
    "name_en": "Puerto Rico"
  },
  {
    "area_code": "+46",
    "country_id": 166,
    "name_cn": "瑞典",
    "name_en": "Sweden"
  },
  {
    "area_code": "+41",
    "country_id": 167,
    "name_cn": "瑞士",
    "name_en": "Switzerland"
  },
  {
    "area_code": "+357",
    "country_id": 43,
    "name_cn": "塞浦路斯",
    "name_en": "Cyprus"
  },
  {
    "area_code": "+503",
    "country_id": 50,
    "name_cn": "萨尔瓦多",
    "name_en": "El Salvador"
  },
  {
    "area_code": "+7",
    "country_id": 86,
    "name_cn": "哈萨克斯坦",
    "name_en": "Kazakstan"
  },
  {
    "area_code": "+1758",
    "country_id": 143,
    "name_cn": "圣卢西亚",
    "name_en": "Saint Lueia"
  },
  {
    "area_code": "+1784",
    "country_id": 144,
    "name_cn": "圣文森特岛",
    "name_en": "Saint Vincent"
  },
  {
    "area_code": "+508",
    "country_id": 222,
    "name_cn": "圣皮埃尔和密克隆群岛",
    "name_en": "SaintPierreandMiquelon"
  },
  {
    "area_code": "+378",
    "country_id": 147,
    "name_cn": "圣马力诺",
    "name_en": "San Marino"
  },
  {
    "area_code": "+239",
    "country_id": 148,
    "name_cn": "圣多美和普林西比",
    "name_en": "Sao Tome and Principe"
  },
  {
    "area_code": "+966",
    "country_id": 149,
    "name_cn": "沙特阿拉伯",
    "name_en": "Saudi Arabia"
  },
  {
    "area_code": "+221",
    "country_id": 150,
    "name_cn": "塞内加尔",
    "name_en": "Senegal"
  },
  {
    "area_code": "+381",
    "country_id": 223,
    "name_cn": "塞尔维亚",
    "name_en": "Serbia"
  },
  {
    "area_code": "+248",
    "country_id": 151,
    "name_cn": "塞舌尔",
    "name_en": "Seychelles"
  },
  {
    "area_code": "+232",
    "country_id": 152,
    "name_cn": "塞拉利昂",
    "name_en": "Sierra Leone"
  },
  {
    "area_code": "+421",
    "country_id": 154,
    "name_cn": "斯洛伐克",
    "name_en": "Slovakia"
  },
  {
    "area_code": "+386",
    "country_id": 155,
    "name_cn": "斯洛文尼亚",
    "name_en": "Slovenia"
  },
  {
    "area_code": "+677",
    "country_id": 156,
    "name_cn": "所罗门群岛",
    "name_en": "Solomon Islands"
  },
  {
    "area_code": "+94",
    "country_id": 160,
    "name_cn": "斯里兰卡",
    "name_en": "Sri Lanka"
  },
  {
    "area_code": "+290",
    "country_id": 221,
    "name_cn": "圣赫勒拿岛",
    "name_en": "St.Helena"
  },
  {
    "area_code": "+1758",
    "country_id": 161,
    "name_cn": "圣卢西亚",
    "name_en": "St.Lucia"
  },
  {
    "area_code": "+1784",
    "country_id": 162,
    "name_cn": "圣文森特",
    "name_en": "St.Vincent"
  },
  {
    "area_code": "+597",
    "country_id": 164,
    "name_cn": "苏里南",
    "name_en": "Suriname"
  },
  {
    "area_code": "+268",
    "country_id": 165,
    "name_cn": "斯威士兰",
    "name_en": "Swaziland"
  },
  {
    "area_code": "+992",
    "country_id": 170,
    "name_cn": "塔吉克斯坦",
    "name_en": "Tajikstan"
  },
  {
    "area_code": "+255",
    "country_id": 171,
    "name_cn": "坦桑尼亚",
    "name_en": "Tanzania"
  },

  {
    "area_code": "+690",
    "country_id": 224,
    "name_cn": "托克劳群岛",
    "name_en": "Tokelau"
  },
  {
    "area_code": "+676",
    "country_id": 174,
    "name_cn": "汤加",
    "name_en": "Tonga"
  },
  {
    "area_code": "+1868",
    "country_id": 175,
    "name_cn": "特立尼达和多巴哥",
    "name_en": "Trinidad and Tobago"
  },
  {
    "area_code": "+216",
    "country_id": 176,
    "name_cn": "突尼斯",
    "name_en": "Tunisia"
  },
  {
    "area_code": "+90",
    "country_id": 177,
    "name_cn": "土耳其",
    "name_en": "Turkey"
  },
  {
    "area_code": "+993",
    "country_id": 178,
    "name_cn": "土库曼斯坦",
    "name_en": "Turkmenistan"
  },
  {
    "area_code": "+688",
    "country_id": 225,
    "name_cn": "图瓦卢",
    "name_en": "Tuvalu"
  },
  {
    "area_code": "+673",
    "country_id": 26,
    "name_cn": "文莱",
    "name_en": "Brunei"
  },
  {
    "area_code": "+502",
    "country_id": 66,
    "name_cn": "危地马拉",
    "name_en": "Guatemala"
  },
  {
    "area_code": "+256",
    "country_id": 179,
    "name_cn": "乌干达",
    "name_en": "Uganda"
  },
  {
    "area_code": "+380",
    "country_id": 180,
    "name_cn": "乌克兰",
    "name_en": "Ukraine"
  },
  {
    "area_code": "+598",
    "country_id": 184,
    "name_cn": "乌拉圭",
    "name_en": "Uruguay"
  },
  {
    "area_code": "+998",
    "country_id": 185,
    "name_cn": "乌兹别克斯坦",
    "name_en": "Uzbekistan"
  },
  {
    "area_code": "+678",
    "country_id": 226,
    "name_cn": "瓦努阿图",
    "name_en": "Vanuatu"
  },
  {
    "area_code": "+58",
    "country_id": 186,
    "name_cn": "委内瑞拉",
    "name_en": "Venezuela"
  },
  {
    "area_code": "+681",
    "country_id": 228,
    "name_cn": "瓦利斯和富图纳",
    "name_en": "WallisandFutuna"
  },
  {
    "area_code": "+30",
    "country_id": 63,
    "name_cn": "希腊",
    "name_en": "Greece"
  },
  {
    "area_code": "+36",
    "country_id": 72,
    "name_cn": "匈牙利",
    "name_en": "Hungary"
  },
  {
    "area_code": "+64",
    "country_id": 122,
    "name_cn": "新西兰",
    "name_en": "New Zealand"
  },
  {
    "area_code": "+687",
    "country_id": 216,
    "name_cn": "新喀里多尼亚",
    "name_en": "NewCaledonia"
  },
  {
    "area_code": "+505",
    "country_id": 123,
    "name_cn": "尼加拉瓜",
    "name_en": "Nicaragua"
  },
  {
    "area_code": "+685",
    "country_id": 146,
    "name_cn": "西萨摩亚",
    "name_en": "Samoa Western"
  },
  {
    "area_code": "+65",
    "country_id": 153,
    "name_cn": "新加坡",
    "name_en": "Singapore"
  },
  {
    "area_code": "+34",
    "country_id": 159,
    "name_cn": "西班牙",
    "name_en": "Spain"
  },
  {
    "area_code": "+374",
    "country_id": 9,
    "name_cn": "亚美尼亚",
    "name_en": "Armenia"
  },
  {
    "area_code": "+39",
    "country_id": 241,
    "name_cn": "意大利",
    "name_en": "Italy"
  },
  {
    "area_code": "+44",
    "country_id": 242,
    "name_cn": "英国",
    "name_en": "Britain"
  },
  {
    "area_code": "+91",
    "country_id": 243,
    "name_cn": "印度",
    "name_en": "India"
  },
  {
    "area_code": "+62",
    "country_id": 244,
    "name_cn": "印度尼西亚",
    "name_en": "Indonesia"
  },
  {
    "area_code": "+1284",
    "country_id": 229,
    "name_cn": "英属维尔京群岛",
    "name_en": "British Virgin Islands"
  },
  {
    "area_code": "+56",
    "country_id": 36,
    "name_cn": "智利",
    "name_en": "Chile"
  },
  {
    "area_code": "+350",
    "country_id": 62,
    "name_cn": "直布罗陀",
    "name_en": "Gibraltar"
  },
  {
    "area_code": "+243",
    "country_id": 192,
    "name_cn": "扎伊尔",
    "name_en": "Zaire"
  },
  {
    "area_code": "+260",
    "country_id": 193,
    "name_cn": "赞比亚",
    "name_en": "Zambia"
  }
]


// WEBPACK FOOTER //
// ./src/lib/country.js